var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.124,
    height: 12.203,
    viewBox: "0 0 23.124 12.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#45338c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-78.617,1368.638c-.235,0-.469,0-.7,0a1.881,1.881,0,0,1-1.692-1.309c-.211-.652-.49-1.283-.733-1.926a1.1,1.1,0,0,1,.347-1.45.81.81,0,0,0,.123-.125c.43-.623.763-.411,1.234-.088a5.362,5.362,0,0,1,.873.846.914.914,0,0,1,.2.432.853.853,0,0,0,1.057.667c.672-.176,1.352-.322,2.015-.526.441-.136.858-.352,1.287-.527.168-.069.351-.105.511-.188.344-.179.668-.4,1.017-.565a3.525,3.525,0,0,1,1.021-.382,8.953,8.953,0,0,0,2.168-.907,21.7,21.7,0,0,0,2.026-.849c1.064-.556,2.091-1.182,3.136-1.775.539-.307,1.112-.564,1.616-.92,1.013-.717,1.989-1.485,2.978-2.234a2.53,2.53,0,0,1,.307-.267.847.847,0,0,1,1.046.606,1.621,1.621,0,0,1-.359,1.434c-.42.416-.838.834-1.231,1.275-.18.2-.246.534-.453.681a18.292,18.292,0,0,1-2.917,2.158c-.874.394-1.661.976-2.508,1.435-.671.363-1.375.664-2.063,1-.546.264-1.087.538-1.637.794-.172.08-.371.1-.546.172a8.145,8.145,0,0,0-1.817.817c-.606.46-1.349.444-1.972.8a5.648,5.648,0,0,1-1.243.389c-.682.2-1.359.414-2.051.565a4.975,4.975,0,0,1-1.04.013C-78.617,1368.662-78.617,1368.65-78.617,1368.638Z",
    transform: "translate(81.879 -1356.495)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick5);
export default __webpack_public_path__ + "static/media/tick-5.1dfd652f03415e03ac8040bd9e1a152a.svg";
export { ForwardRef as ReactComponent };